import { render, staticRenderFns } from "./open_ins_list.vue?vue&type=template&id=71fe1e8f&scoped=true"
import script from "./open_ins_list.vue?vue&type=script&lang=ts"
export * from "./open_ins_list.vue?vue&type=script&lang=ts"
import style0 from "./open_ins_list.vue?vue&type=style&index=0&id=71fe1e8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe1e8f",
  null
  
)

export default component.exports